module.exports = __webpack_public_path__ + "img/article-image-2.642357f0.webp";